import React from "react";

import ProductCategoryList from "../../../Components/GMS/Products/ProductCategory/ProductCategoryList";

function ProductCategories() {
  return (
    <React.Fragment>
        <ProductCategoryList />
    </React.Fragment>
  );
}

export default ProductCategories;
